export default "__VITE_ASSET__B$xryieQ__"